<template>
    <div class="newsletter-action__content__interaction__scroll-container">
        <div class="newsletter-action__content__padding-correction">
            <div class="newsletter-action__content__step">
                <h2>
                    {{ (helpers.getLocale() === 'nl')
                    ? 'De stemming is gesloten, binnenkort maken we de favorieten bekend.'
                    : 'Voting is now closed, soon we will announce the favourites.' }}
                </h2>
                <span>{{ (helpers.getLocale() === 'nl')
                    ? 'Niks missen? Schrijf je in voor onze nieuwsbrief.'
                    : "Don't want to miss anything? Sign up for our newsletter." }}</span>

                <br>
                <button @click="nextSlide()" class="btn btn-primary">
                    {{ (helpers.getLocale() === 'nl')
                    ? 'Schrijf je in'
                    : 'Subscribe'
                    }}
                    <span class="icon-arrow"><img src="/images/arrow_2.svg" alt=""></span></button>

            </div>
        </div>
    </div>
</template>

<script>
    import helpers from 'assets/js/site/helpers';

    export default {

        data: () => ({
           helpers: helpers
        }),

        props: {
            translations: { required: true }
        },

        mounted: function() {
            this.$parent.$refs.action_container.classList.add('newsletter-action__container--extended');
            this.$parent.$refs.gradient_container.classList.add('newsletter-action__container__gradient--extended');
        },

        methods: {
            nextSlide: function() {
                this.$parent.$refs.action_container.classList.remove('newsletter-action__container--extended');
                this.$parent.$refs.gradient_container.classList.remove('newsletter-action__container__gradient--extended');

                this.$emit('change-component', { slide_name: 'subscribe'});
            }
        }
    }
</script>


<style lang="scss" scoped>
    @media screen and (min-width: 686px) {
        .newsletter-action__content__step {
            width: 362px;
        }
        .newsletter-action__content__padding-correction {
            padding: 0 75px;
        }
        .newsletter-action__container {
            right: -685px;
        }
        .newsletter-action__container--extended {
            right: -512px;
        }
    }
    h2 {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/newsletter-widget/tour-intro-slide.vue